import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
} from "antd";
import moment from "moment";
import {
  formatNumberUS,
  namePattern,
  servicesNamePattern,
  tenDigit,
} from "utility/constant";

import FormDatePicker from "components/common/FormDatePicker";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { disabledDate, specialDoctorID } from "utils/general";

export default function IndividualInvite({
  title,
  open,
  onOk,
  onCancel,
  inviteTour,
  loading,
  IndInvite,
  onFinishFailed,
  memberForm,
  setInviteTourIndex,
  setInviteIndDependent,
  setInvSuccessModel,
  intialDoctor,
  dependentList,
  doctorList,
}) {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const initialDoctorId =
    doctorList?.find((d) => d.name === selectedDoctor)?.id || null;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const doctorID = searchParams.get("dpcDoctorID");

  const [form] = Form.useForm();

  const handleModalDestroy = () => {
    form.resetFields();
  };

  return (
    <Modal
      title={title}
      width={600}
      visible={open}
      onOk={onOk}
      onCancel={onCancel}
      keyboard={false}
      centered
      className="form-modal inv-second-step desired-modal"
      footer={null}
      afterClose={handleModalDestroy}
    >
      <Form
        name="employee"
        onFinish={IndInvite}
        autoComplete="off"
        id="memberInvite"
        layout="vertical"
        form={form}
      >
        <Row gutter={20}>
          <Col span={12} md={12} xs={24} sm={24}>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please enter first name",
                },
                {
                  pattern: namePattern,
                  message: "Please enter a valid first name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12} md={12} xs={24} sm={24}>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please enter last name",
                },

                {
                  pattern: namePattern,
                  message: "Please enter a valid last name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12} md={12} xs={24} sm={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  validator: (_, value) => {
                    value = value?.trim();

                    // Required check
                    if (!value) {
                      return Promise.reject(new Error("Please enter email"));
                    }

                    // Email pattern check
                    const emailPattern =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!emailPattern.test(value)) {
                      return Promise.reject(
                        new Error("Please enter a valid email")
                      );
                    }

                    // Duplicate check
                    const isDuplicate = dependentList?.some(
                      (item) =>
                        item?.email &&
                        item.email.toLowerCase() === value.toLowerCase()
                    );

                    if (isDuplicate) {
                      return Promise.reject(
                        new Error("This email already exists.")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12} md={12} xs={24} sm={24}>
            <Form.Item
              label="Phone"
              name="phone"
              rules={[
                {
                  required: true,
                  message: "Please enter phone number",
                },
                {
                  pattern: tenDigit,
                  message: "Please enter a valid phone number",
                },
              ]}
            >
              <InputNumber
                controls={false}
                formatter={(value) => formatNumberUS(value)}
                parser={(value) => {
                  const cleanedValue = value.replace(/\D/g, "");
                  return cleanedValue.slice(0, 10);
                }}
                style={{ width: "100%", borderRadius: "5px" }}
              />
            </Form.Item>
          </Col>

          <Col span={12} md={12} xs={24} sm={24}>
            {!doctorList && !intialDoctor ? (
              <Form.Item
                label="Relation"
                name="relation"
                rules={[
                  {
                    pattern: servicesNamePattern,
                    message: "Please enter a valid relation",
                  },
                  {
                    required: true,
                    message: "Please enter relation",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ) : (
              <Form.Item
                label="Choose Your Medical Provider"
                name="doctor"
                // initialValue={intialDoctor}
                rules={[
                  {
                    required: true,
                    message: "Please select any employer",
                  },
                ]}
              >
                <Select
                  allowClear
                  placeholder="Select medical provider"
                  value={intialDoctor}
                  onChange={(value) => {
                    setSelectedDoctor(value);
                    setIsSelected(true);
                  }}
                >
                  {/*
                    Temporary logic for handling the special doctor (Dr. Boucher) until December 1st:
                    1. By default, show all doctors except the one with `specialDoctorID` (Dr. Boucher).
                    2. If the query parameter contains `specialDoctorID`, then only show that doctor.
                    TODO: Remove this conditional logic after December 1st.
                  */}
                  {/*
                   {doctorList.map((item) => (
                    <Select.Option
                      key={item?.id}
                      value={item?.name} //have start date too, once it is done.
                    >{`${item.name}`}</Select.Option>
                  ))} */}
                  {(doctorID === specialDoctorID
                    ? doctorList.filter((doc) => doc.id === specialDoctorID) // show only that doctor
                    : doctorList.filter((doc) => doc.id !== specialDoctorID)
                  ) // show all except that doctor
                    .map((item) => (
                      <Select.Option key={item?.id} value={item?.name}>
                        {item?.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}
          </Col>

          <Col span={12} md={12} xs={24} sm={24}>
            <FormDatePicker
              name="dob"
              label="Date of Birth"
              disabledDate={disabledDate}
              doctorId={isSelected ? initialDoctorId : doctorID}
              defaultPickerValue={moment()}
            />
          </Col>

          <Col
            span={12}
            md={24}
            xs={24}
            sm={24}
            style={{ textAlign: "center" }}
          >
            {inviteTour ? (
              <Button
                type="primary"
                className="theme-btn inv-third-step"
                onClick={() => {
                  setTimeout(() => {
                    setInviteTourIndex(3);
                  }, 500);
                  setInviteIndDependent(false);
                  setInvSuccessModel(true);
                }}
                style={{ marginTop: "0px !important" }}
              >
                Send Invite
              </Button>
            ) : (
              <Button
                type="primary"
                className="theme-btn inv-third-step"
                htmlType="submit"
                form="memberInvite"
                disabled={dependentList?.length === 5}
                key="submit"
                loading={loading}
                style={{ marginTop: "0px !important" }}
              >
                Send Invite
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
